import { AlgoliaObject } from '@marmon/shared/types/algolia';
import { Organization } from '../interfaces';

export class AlgoliaOrganization extends AlgoliaObject {
	name!: string;
	domains!: string[];
	leaderIds!: string[];

	constructor(base: Organization) {
		super(base);

		this.name = base.name;
		this.domains = [...(base.domains ?? [])];
		this.leaderIds = (base.leaders ?? []).map((leader) => leader.id);
	}

	/**
	 * Determines if this algolia organization instance is equal to another one. We avoid
	 * checking against the created and updated timestamps due to those values not holding
	 * any merit or value in terms of the Algolia data object.
	 */
	isEqual(other: AlgoliaOrganization) {
		if (other.objectID !== this.objectID) return false;
		if (other.name !== this.name) return false;
		if (JSON.stringify(other.domains) !== JSON.stringify(this.domains)) {
			return false;
		}
		if (
			JSON.stringify(other.leaderIds) !== JSON.stringify(this.leaderIds)
		) {
			return false;
		}

		return true;
	}
}
